import _ from "lodash";
import { mapActions, mapGetters } from "vuex";
import { AddModuleUsed } from "./globals";
import * as CONFIG from "@/config.js";

/* Create mapActions and mapGetters for a RestModule (and similar modules)
for Code Modules. And loads them!

Name is the name to use when creating the methods/getters etc ie "AssignedCustomer"
moduleName is the name of A Module ie 'Test' for the 'TestModule'

Then the following actions and getters are created

mapActions({
    createNewAssignedCustomer: 'TestModule/createNew',
    saveAssignedCustomerItem: 'TestModule/saveItem',
    getAssignedCustomerById: 'TestModule/getById',
    patchAssignedCustomerItem: 'TestModule/pathItem',

    getAllAssignedCustomer: 'TestModule/getAll', //called by GetRelatedAssignedCustomerList and when query changes
});

mapGetters({
    optionAssignedCustomerItems: 'TestModule/code_items',
    optionAssignedCustomerWorking: 'TestModule/working',
    optionAssignedCustomerItemsById: 'TestModule/itemsByID',
});
 */

export default function (prefix, moduleName, queryFunction) {
    var actionList = {};
    var fetchActionList = {};
    var getterList = {};

    if (CONFIG.Debug) {
        AddModuleUsed(moduleName);
    }

    actionList["createNew" + prefix] = moduleName + "Module/createNew";
    actionList["save" + prefix + "Item"] = moduleName + "Module/saveItem";
    actionList["get" + prefix + "ById"] = moduleName + "Module/getById";
    actionList["patch" + prefix + "Item"] = moduleName + "Module/patchItem";

    fetchActionList["getAll" + prefix] = moduleName + "Module/getAll";

    getterList["option" + prefix + "Items"] = moduleName + "Module/code_items";
    getterList["option" + prefix + "ItemsById"] =
        moduleName + "Module/code_itemsByID";
    getterList["option" + prefix + "Working"] = moduleName + "Module/working";
    getterList["get" + prefix + "NewItem"] = moduleName + "Module/item";

    /* With a name of "Customer" create a Method GetRelatedCustomerList(list_options)
       That can be called to load the code options
     */

    var getCodeTablesMethods = {};
    var function_name = "GetRelated" + prefix + "List";

    getCodeTablesMethods[function_name] = function (list_options) {
        var vm = this;

        list_options = this[prefix + "Options"];

        if (list_options) {
            // Only do fetch if there is a value

            // the `"option" + prefix + "Items"` is looking for `code_items` so make sure it's going to be in the code
            list_options._code = true;

            var onBeforeFilterList = vm["OnBefore" + function_name]; // Looks for "OnBeforeGetRelatedCustomerList" function
            var onAfterFilterList = vm["OnAfter" + function_name]; // Looks for "OnAfterGetRelatedCustomerList" function

            if (onBeforeFilterList) onBeforeFilterList(list_options);
            vm["getAll" + prefix]({ ...list_options }).then(function (results) {
                if (onAfterFilterList) {
                    onAfterFilterList(results);
                }
            });
        }
    };
    getCodeTablesMethods["load" + prefix + "Related"] = function () {
        const vm = this;

        if (vm[prefix + "Options"] !== null) {
            vm["GetRelated" + prefix + "List"]();
        }
    };

    return {
        methods: {
            ...getCodeTablesMethods,
            ...mapActions({ ...fetchActionList, ...actionList }),
        },
        computed: {
            ...mapGetters(getterList),
            [prefix + "Options"]: queryFunction,
        },
        watch: {
            [prefix + "Options"]: {
                handler: function (newVal) {
                    this["load" + prefix + "Related"]();
                },
                deep: true,
            },
        },
        created() {
            this["load" + prefix + "Related"]();
        },
    };
}
